// Interface Log
const sapIntDatapack = {
  reqMsg: 'Request Message',
  reqDate: 'Request Time',
  respDate: 'Response Time',
  respMsg: 'Response Message',
  reqDateBegin: 'Request Time Begin',
  reqDateEnd: 'Request Time End',
  inputDate: 'Input Time',
  inputDateBegin: 'Input Time Begin',
  inputDateEnd: 'Input Time End',
  inputUserNo: 'Input User',
  businessType: 'Business Type',
  dealStatus: 'Deal Status',
  dealResult: 'Deal Result',
  detail: 'Detail',
  basicInfo: 'Basic Info',
  requestMsg: 'Request Message Detail',
  responseMsg: 'Response Message Detail'
};
export default sapIntDatapack;



// WEBPACK FOOTER //
// ./src/page/log/sapIntDatapack/lang/sapIntDatapack.en.js